import { AgentModel } from 'api-hooks/agent';
import { BankAccountModel } from 'api-hooks/bank-account';
import { CashAccountModel } from 'api-hooks/cash-account';
import { EmployeeLiteModel } from 'api-hooks/employee';
import { PaymentChannelLiteModel } from 'api-hooks/payment-channel';
import { PurchaseRelatedModel } from 'api-hooks/sale/common';
import { TourLiteModel } from 'api-hooks/tour/tour-list/tour-detail';
import { Expose, Type } from 'class-transformer';
import {
  PurchaseStatusEnum,
  PurchaseTransactionTypeEnum,
} from 'common/constants/enum';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

export class SaleRelatedModel extends PurchaseRelatedModel {
  @Type(() => PurchaseRelatedModel)
  purchases: PurchaseRelatedModel[];
}
// DON'T DELETE THIS COMMENT CODE
// export enum PurchaseStatusEnum {
//   // TAB PROCESS
//   pending = 'pending',

//   // TAB NEED APPROVAL
//   pending_approval = 'pending_approval',
//   pending_void_approval = 'pending_void_approval',
//   draft = 'draft',
//   void_draft = 'void_draft',

//   // TAB REJECT APPROVAL
//   rejected_approval = 'rejected_approval',

//   //TAB COMPLETE
//   completed = 'completed',
//   void = 'void',
//   refund = 'refund',

//   // HIDDEN
//   archived = 'archived',
//   waiting = 'waiting',

//   // // OTHER
//   // active = 'active',
//   // openTicket = 'open_ticket',
//   // rescheduled = 'rescheduled',
//   // refund = 'refund',
// }

export enum PurchaseTypeEnum {
  Sales = 'sales',
  Tour = 'tour',
  Product = 'product',
}

export class RefundPurchasesModel {
  id: string;
  customer: string;
  number: string;
  reason: string;
  status: string;

  @Type(() => Number)
  amount: number;

  @Expose({ name: 'invoice_number' })
  invoiceNumber: string;

  @Expose({ name: 'refund_id' })
  refundId: string;

  @Expose({ name: 'requested_at' })
  @Type(() => Date)
  requestedAt: Date;
}

export class PurchaseLiteModel extends CommonModel {
  number: string;
  code: string;
  description: string;
  status: PurchaseStatusEnum;
  type: PurchaseTypeEnum;

  @Type(() => AgentModel)
  agent: AgentModel;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date | null;

  @Expose({ name: 'ref_id' })
  refId: string;

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;
}

export class AgentCommissionPurchaseModel {
  id: string;

  accountable: CashAccountModel | BankAccountModel | null;

  @Expose({ name: 'accontable_type' })
  accountableType: 'CashAccount' | 'BankAccount' | null;

  @Expose({ name: 'acknowledged_at' })
  @Type(() => Date)
  acknowledgedAt: Date | null;

  @Expose({ name: 'amount' })
  @Type(() => Number)
  amount: number;

  @Expose({ name: 'description' })
  description: string | null;
}

export class PurchaseModel extends PurchaseLiteModel {
  @Expose({ name: 'invoice_number' })
  invoiceNumber?: string | null;

  @Expose({ name: 'invoice_ref_id' })
  invoiceRefId?: string;

  @Expose({ name: 'payment_channel' })
  @Type(() => PaymentChannelLiteModel)
  paymentChannel: PaymentChannelLiteModel | null;

  @Type(() => TourLiteModel)
  tour: TourLiteModel | null;

  @Expose({ name: 'waiting_id' })
  waitingId: string | null;

  @Type(() => Number)
  discount: number;

  @Expose({ name: 'other_cost' })
  @Type(() => Number)
  otherCost: number;

  @Type(() => Number)
  total: number;

  @Type(() => SaleRelatedModel)
  sale: SaleRelatedModel | null;

  @Expose({ name: 'transaction_type' })
  transactionType: PurchaseTransactionTypeEnum;

  @Expose({ name: 'release_purchases' })
  @Type(() => RefundPurchasesModel)
  releasePurchases: RefundPurchasesModel[];

  @Expose({ name: 'agent_commission' })
  @Type(() => AgentCommissionPurchaseModel)
  agentCommission: AgentCommissionPurchaseModel | null;

  @Expose({ name: 'is_resolved' })
  isResolved: boolean;

  @Expose({ name: 'children_purchases' })
  @Type(() => PurchaseLiteModel)
  childrenPurchases?: PurchaseLiteModel[];

  @Expose({ name: 'parent_purchase' })
  @Type(() => PurchaseLiteModel)
  parentPurchase?: PurchaseLiteModel;
}

export type getPurchasesInput = {
  params: CommonParamInput;
};

export type getPurchaseInput = {
  id: string;
};

export type ReceiveAgentCommissionMutationInput = {
  acknowledgedAt: Date;
  accountableType: string;
  description?: string | null;
  accountableId: string;
};

export type ReceiveAgentCommissionMutationUpdateInput = {
  id: string;
  body: ReceiveAgentCommissionMutationInput;
};
